import cn from "classnames";
import { FC } from "react";
import { getBinaryValueFromAddress } from "./SubnetCalculator.helpers";
import { getDataAutomationGroup } from "@/helpers";
import styles from "./SubnetCalculator.module.css";

interface AllocationTableProps {
  ipAddress: string;
  maskBits: number;
  subnetBits: number;
}

export const AllocationTable: FC<AllocationTableProps> = ({
  ipAddress,
  maskBits,
  subnetBits,
}) => {
  const decimals = [...ipAddress.split(".")];
  const octets = [
    ...ipAddress
      .split(".")
      .map((part) => parseInt(part, 10).toString(16).toUpperCase()),
  ];
  const bits = getBinaryValueFromAddress(ipAddress);

  return (
    <div className={cn("mt-10", styles.scroller)}>
      <table
        className="text-swdc-gray-400 text-body-s table-fixed border-collapse bg-white"
        {...getDataAutomationGroup("table")}
      >
        <tbody>
          <tr>
            <th
              className="border-swdc-silver-400 text-swdc-black-600 min-w-36 border p-2 text-left font-bold lg:min-w-48 lg:p-4"
              scope="row"
            >
              IP Address
            </th>
            {decimals.map((decimal, index) => (
              <td
                key={`${decimal}-${index}`}
                className="border-swdc-silver-400 border p-2 text-center lg:p-4"
                colSpan={8}
              >
                {decimal}
              </td>
            ))}
          </tr>
          <tr>
            <th
              className="border-swdc-silver-400 text-swdc-black-600 min-w-36 border p-2 text-left font-bold lg:p-4"
              scope="row"
            >
              Octet Value
            </th>
            {octets.map((octet, index) => (
              <td
                key={`octet-value-${octet}-${index}`}
                className="border-swdc-silver-400 border p-2 text-center lg:p-4"
                colSpan={8}
              >
                {octet}
              </td>
            ))}
          </tr>
          <tr>
            <th
              className="border-swdc-silver-400 text-swdc-black-600 min-w-36 border p-2 text-left font-bold lg:p-4"
              scope="row"
            >
              Octet Number
            </th>
            {octets.map((_, index) => (
              <td
                key={`octet-number-${index}`}
                className="border-swdc-silver-400 border p-2 text-center lg:p-4"
                colSpan={8}
              >
                {index + 1}
              </td>
            ))}
          </tr>
          <tr>
            <th
              className="border-swdc-silver-400 bg-swdc-cool-gray-200 text-swdc-black-600 border p-2 text-left font-bold lg:p-4"
              scope="row"
            >
              Bit Number
            </th>
            {[...bits].map((bit, index) => (
              <td
                key={`bit-number-${bit}-${index}`}
                className={cn(
                  "border-swdc-silver-400 min-w-[1.32rem] border text-center lg:min-w-[2.03rem]",
                  index < maskBits + subnetBits
                    ? index < maskBits
                      ? "bg-swdc-cool-gray-200"
                      : "bg-swdc-green-500 text-swdc-black-600"
                    : "bg-white",
                )}
              >
                {index + 1}
              </td>
            ))}
          </tr>
          <tr>
            <th
              className="border-swdc-silver-400 bg-swdc-cool-gray-200 text-swdc-black-600 border p-2 text-left font-bold lg:p-4"
              scope="row"
            >
              Bit Value
            </th>
            {[...bits].map((bit, index) => (
              <td
                key={`bit-value-${index}`}
                className={cn(
                  "border-swdc-silver-400 border text-center",
                  index < maskBits + subnetBits
                    ? index < maskBits
                      ? "bg-swdc-cool-gray-200"
                      : "bg-swdc-green-500 text-swdc-black-600"
                    : "bg-white",
                )}
              >
                {bit}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};
